/* eslint-disable complexity */
import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import {
    Icon,
    IconNameTypes
} from "../../../../libraries/wpl/foundations/src/index";

//Types
export interface Gradient {
    firstColor: string;
    secondColor: string;
}

export interface SolutionsCardProps {
    href: string;
    title: string;
    body: string;
    icon: IconNameTypes;
    gradient: Gradient;
    className?: string;
}

export const SolutionsCard = ({
    href,
    title,
    body,
    icon,
    gradient,
    className
}: SolutionsCardProps) => {
    const shadow = `${token("space.025")} ${token("space.025")} ${token(
        "space.150"
    )} #c1c7d0`;

    const panelStyle = css({
        "display": "flex",
        "flexWrap": "wrap",
        "backgroundImage": `linear-gradient( to bottom right, ${gradient.firstColor}, ${gradient.secondColor} )`,
        "borderRadius": token("space.050"),
        "position": "relative",
        "transition": "all 0.5s ease-in-out",
        "&:hover": {
            boxShadow: shadow,
            opacity: 1,
            transform: "scale(1.01)"
        },
        "&:hover::after": {
            opacity: 0,
            transform: "scale(1)"
        }
    });

    const textStyle = css({
        display: "block",
        color: "#172b4d",
        padding: token("space.250")
    });

    const iconStyle = css({
        position: "absolute",
        insetInlineEnd: 0,
        insetBlockStart: 0,
        padding: token("space.200")
    });

    return (
        <div css={panelStyle}>
            <a
                href={href}
                className={className}
                css={css({
                    textDecoration: "none"
                })}
                data-event="clicked"
                data-event-component="linkButton"
                data-event-container="globalNavWacDropdownContainer"
            >
                <div css={textStyle}>
                    <div
                        css={css({
                            fontSize: token("space.200")
                        })}
                    >
                        {title}
                    </div>
                    <div
                        css={css({
                            marginBlockStart: token("space.250"),
                            fontSize: "14px",
                            display: "flex",
                            flexWrap: "wrap"
                        })}
                    >
                        {body}
                    </div>
                </div>
                <div css={iconStyle}>
                    <Icon name={icon} size="small" color="#172b4d" />
                </div>
            </a>
        </div>
    );
};
